/**
 * A13 — Clôture Comptable: FE form ↔ BE situation_cloture_comptable column mapping.
 * Writable columns exposed by ClotureComptablePage (excludes id, created_at, updated_at).
 */

export const CLOTURE_WRITABLE_FIELDS = [
  'cloture_ref',
  'exercice_fiscal',
  'periode_cloture',
  'type_cloture',
  'date_debut_periode',
  'date_fin_periode',
  'date_cloture',
  'statut_cloture',
  'responsable_cloture',
  'progression_pourcent',
  'controles_effectues',
  'anomalies_ouvertes',
  'validation_comptable',
  'validation_daf',
  'validation_dg',
  'conformite_procedures',
  'notes',
];

const DATE_FIELDS = new Set([
  'date_debut_periode',
  'date_fin_periode',
  'date_cloture',
]);

const DECIMAL_FIELDS = new Set(['progression_pourcent']);

const INTEGER_FIELDS = new Set([
  'controles_effectues',
  'anomalies_ouvertes',
  'validation_comptable',
  'validation_daf',
  'validation_dg',
  'conformite_procedures',
]);

const INTEGER_DEFAULTS = Object.freeze({
  controles_effectues: 0,
  anomalies_ouvertes: 0,
  validation_comptable: 0,
  validation_daf: 0,
  validation_dg: 0,
  conformite_procedures: 0,
});

export const EMPTY_CLOTURE_FORM = Object.freeze({
  ...CLOTURE_WRITABLE_FIELDS.reduce((acc, field) => {
    acc[field] = INTEGER_FIELDS.has(field) ? String(INTEGER_DEFAULTS[field]) : '';
    return acc;
  }, {}),
});

const normalizeDate = (value) => {
  if (value == null || value === '') return '';
  if (typeof value === 'string') return value.split('T')[0];
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().split('T')[0];
  }
  return String(value);
};

const toFormScalar = (field, value) => {
  if (value == null) {
    return INTEGER_FIELDS.has(field) ? String(INTEGER_DEFAULTS[field]) : '';
  }
  if (DATE_FIELDS.has(field)) return normalizeDate(value);
  if (INTEGER_FIELDS.has(field)) return value === 1 || value === true ? '1' : '0';
  return value;
};

/** Map API row → form state. */
export const recordToFormData = (record = {}) => {
  const form = { ...EMPTY_CLOTURE_FORM };
  CLOTURE_WRITABLE_FIELDS.forEach((field) => {
    if (record[field] !== undefined && record[field] !== null) {
      form[field] = toFormScalar(field, record[field]);
    }
  });
  return form;
};

/** Map form state → API payload (typed for situation_cloture_comptable). */
export const buildCloturePayload = (formData = {}) => {
  const payload = {};

  CLOTURE_WRITABLE_FIELDS.forEach((field) => {
    const raw = formData[field];

    if (DECIMAL_FIELDS.has(field)) {
      payload[field] = raw === '' || raw == null ? 0 : parseFloat(raw) || 0;
      return;
    }

    if (INTEGER_FIELDS.has(field)) {
      if (raw === '' || raw == null) {
        payload[field] = INTEGER_DEFAULTS[field];
        return;
      }
      payload[field] = raw === true || raw === 1 || raw === '1' ? 1 : 0;
      return;
    }

    if (DATE_FIELDS.has(field)) {
      payload[field] = raw === '' || raw == null ? null : normalizeDate(raw);
      return;
    }

    payload[field] = raw === '' || raw == null ? null : raw;
  });

  return payload;
};
